import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MasterRolePermission } from '../Models/master-role-permission';
import { LogFileCnvrtCSV } from '../Models/log-file-cnvrt-csv';
import * as fs from 'file-saver';
import { ExportExcelService } from '../reports/data-analysis/export-excel.service';
import { DatePipe } from '@angular/common';
//import { ThrowStmt } from '@angular/compiler';
import { FileService } from './file.service';

@Component({
  selector: 'app-log-file-cnvrt-csv',
  templateUrl: './log-file-cnvrt-csv.component.html',
  styleUrls: ['./log-file-cnvrt-csv.component.css']
})
export class LogFileCnvrtCSVComponent {
  LogDate: string = '';
  constructor(private formBuilder: FormBuilder, private router: Router, private excelService: ExportExcelService, private datePipe: DatePipe, private fileService: FileService) { }

  logForm: FormGroup;
  logFileCnvrtCSV: LogFileCnvrtCSV = new LogFileCnvrtCSV();

  ngOnInit(): void {

    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.ViewLogFileCnvrtCSV.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {
        this.InititalizeForm();

      }
    }
    var now = new Date();
    this.LogDate = now.getDate() + '-' + (now.getMonth() + 1) + '-' + now.getFullYear();

  }

  InititalizeForm() {
    this.logForm = this.formBuilder.group({

    })
  }

  SearchData() {
    this.logFileCnvrtCSV.LOG_DATE = this.LogDate;
    var csvdate = this.logFileCnvrtCSV.LOG_DATE;
    // var now = new Date(csvdate);
    // var month = now.getMonth() + 1;
    // var day = now.getDate();
    // var year = now.getFullYear();
    // var latestdate = month  + '-'+ day + '-' + year;       
    let paraDate = this.datePipe.transform(csvdate, 'MM-dd-yyyy');
    var dt = "Log-" + paraDate;
    //var dt = "Log-" + latestdate;

    //var url = "http://localhost:55820/api/"+dt+".txt";
    //var url = "http://192.168.0.204/" + dt + ".txt";
    var url = "http://192.168.1.122:82/" + dt + ".txt";
    var urlfilename = dt + ".txt";
    // const blob = new Blob([url], { type: 'text/csv' });
    // const url1 = window.URL.createObjectURL(blob);
    //window.open(url,"image.jpg");
    //fs.saveAs(url, "image.csv");
    this.download(url, urlfilename);
  

  }

  download(parafilename, logfilename) {
    //this.fileService.downloadFile().subscribe(response => {
    this.fileService.downloadFile(parafilename).subscribe((response: any) => { //when you use stricter type checking
      let blob: any = new Blob([response], { type: 'text/csv; charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      //window.open(url);
      //window.location.href = response.url;
      fs.saveAs(blob, logfilename);
      //}), error => console.log('Error downloading the file'),
    }), (error: any) => alert('Error downloading the file'), //when you use stricter type checking
      () => alert('File downloaded successfully');
      //(error: any) => alert() console.log('Error downloading the file'), //when you use stricter type checking
      //() => console.info('File downloaded successfully');
  }



}